import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        this.enableSorting()

        document.addEventListener(
            'conversions:reorder',
            () => {
                this.reorderConversions()
            },
            false,
        )
    }

    reorderConversions() {
        const conversionGroups = document.querySelectorAll(
            '.conversion-group.list-group-item:not(.hidden-conversion)',
        )

        Array.from(conversionGroups).forEach((conversionGroup, i) => {
            const count = `${i + 1}`
            const orderElement = conversionGroup.querySelector('.order') as HTMLElement
            orderElement.innerHTML = count

            const orderInputField = conversionGroup.querySelector(
                'input[id*="_eval_order"]',
            ) as HTMLInputElement
            orderInputField.value = count
        })
    }

    enableSorting() {
        $('#conversions-settings .sortable').sortable({
            nested: false,
            handle: 'span.move-handler',
            onDrop: ($item, container, _super) => {
                this.reorderConversions()
                _super($item, container)
            },
        })
    }
}
